import React from 'react';
import { useTranslation } from 'react-i18next';
import { useProfileState, useProfileAbility } from 'context/profile';
import { Card, CardBody, Row, Col, CardText, CardImgOverlay } from 'reactstrap';
import types from './Constants/types';
import { ReactComponent as Subir } from 'components/Shared/CreateDocumentSVG/SVG/Subir.svg'
import { ReactComponent as Papel } from 'components/Shared/CreateDocumentSVG/SVG/Papel.svg'
import { ReactComponent as Blanco } from 'components/Shared/CreateDocumentSVG/SVG/Blanco.svg'
import { ReactComponent as Examen } from 'components/Shared/CreateDocumentSVG/SVG/Examen.svg'
import { ReactComponent as Multiple } from 'components/Shared/CreateDocumentSVG/SVG/Multiple.svg'
import { ReactComponent as Massive } from 'components/Shared/CreateDocumentSVG/SVG/Massive.svg'
import styled from 'styled-components';

const svgMapping = {
  template: Papel,
  questionnaire: Examen,
  source: Subir,
  blank: Blanco,
  multiple: Multiple,
  massive: Massive,
  application: Papel,
  pagare: Papel
}

const Icon = ({ tag, ...props }) => {
  const Component = svgMapping[tag];
  return <Component {...props} />
}

const DocumentType = ({ type }) => {
  const { t } = useTranslation();
  return (
    <CardBody>
      <CardImgOverlay>
        <CardText>
          <small className="text-muted">
            {/* Adquiere este servicio por un precio especial. */}
          </small>
        </CardText>
      </CardImgOverlay>
      <Icon tag={type.type} fill={'#f58543'} />
      <CardText className="mt-3">{t(type.label)}</CardText>
    </CardBody>
  );
};

const HoverCard = styled(Card)`
:hover{
  border: 1px solid #f58543;
}
`

const DocumentTypeGrid = ({ selected, handleSelected }) => {
  const profileAbility = useProfileAbility();
  return (
    <Row>
      {types.map((type, index) => {
        let isEnabled = profileAbility.can(type.role);

        return (
          isEnabled &&
          <Col md="6" className="text-center mt-4" key={type.label}>
            <HoverCard
              className="pointer"
             
              id={`create-${type.type}`}
              onClick={() => {
                isEnabled && handleSelected(type.type);
              }}
            >
              <DocumentType
                key={type.label}
                type={type}
                isSelected={type.type === selected}
                isEnabled={isEnabled}
              />
            </HoverCard>
          </Col>
        );
      })}
    </Row>
  );
};
export { types };
export default DocumentTypeGrid;
